import { Controller } from 'stimulus'
import './component.scss'

window.Stimulus.register(
  'filter-search-modal',
  class extends Controller {
    static targets = ['expandableToggle', 'expandableMore', 'searchButton', 'content', 'overlay']

    static CLASSES = {
      ACTIVE_CONTENT: 'filter-search-modal__content--active',
      ACTIVE_OVERLAY: 'filter-search-modal__overlay--active',
      EXPANDED_TOGGLE: 'filter-search-modal__more-toggle--expanded'
    }

    connect() {
      this._restoreFilterStateFromParams()
    }

    openModal() {
      if (!this.hasContentTarget || !this.hasOverlayTarget) return

      this._setBodyOverflow('hidden')
      this._toggleModalVisibility(true)
    }

    closeModal() {
      if (!this.hasContentTarget || !this.hasOverlayTarget) return

      this._setBodyOverflow('')
      this._toggleModalVisibility(false)
    }

    toggleExpandable(event) {
      const toggle = event.currentTarget
      const expandableName = toggle.dataset.expandableName

      const moreSection = this.expandableMoreTargets.find(
        element => element.dataset.expandableName === expandableName
      )

      if (!moreSection) {
        return
      }

      if (moreSection.style.display === 'none' || !moreSection.style.display) {
        moreSection.style.display = 'flex'
        toggle.classList.add(this.constructor.CLASSES.EXPANDED_TOGGLE)
      } else {
        moreSection.style.display = 'none'
        toggle.classList.remove(this.constructor.CLASSES.EXPANDED_TOGGLE)
      }
    }

    performSearch() {
      const buildingTypes = this._getCheckedValues('building_types[]')
      const wallMaterials = this._getCheckedValues('wall_materials[]')
      const themes = this._getCheckedValues('themes[]')
      const insuranceTypes = this._getCheckedValues('insurance_types[]')
      const availableServices = this._getCheckedValues('available_services[]')
      const qualifications = this._getCheckedValues('qualifications[]')
      const preferences = this._getCheckedValues('preferences[]')

      const reviewCount = this._getCheckedRadioValue('review_count')
      const reviewRating = this._getCheckedRadioValue('review_rating')
      const establishedYears = this._getCheckedRadioValue('established_years')
      const constructionCount = this._getCheckedRadioValue('construction_count')

      const params = new URLSearchParams(window.location.search)

      params.delete('building_types[]')
      params.delete('wall_materials[]')
      params.delete('themes[]')
      params.delete('review_count')
      params.delete('review_rating')
      params.delete('established_years')
      params.delete('construction_count')
      params.delete('insurance_types[]')
      params.delete('available_services[]')
      params.delete('qualifications[]')
      params.delete('preferences[]')
      if (buildingTypes.length > 0) {
        buildingTypes.forEach(type => {
          params.append('building_types[]', type)
        })
      }

      if (wallMaterials.length > 0) {
        wallMaterials.forEach(material => {
          params.append('wall_materials[]', material)
        })
      }

      if (themes.length > 0) {
        themes.forEach(theme => {
          params.append('themes[]', theme)
        })
      }

      if (reviewCount != null) {
        params.append('review_count', reviewCount)
      }

      if (reviewRating != null) {
        params.append('review_rating', reviewRating)
      }

      if (establishedYears != null) {
        params.append('established_years', establishedYears)
      }

      if (constructionCount != null) {
        params.append('construction_count', constructionCount)
      }

      if (insuranceTypes.length > 0) {
        insuranceTypes.forEach(type => {
          params.append('insurance_types[]', type)
        })
      }

      if (availableServices.length > 0) {
        availableServices.forEach(service => {
          params.append('available_services[]', service)
        })
      }

      if (qualifications.length > 0) {
        qualifications.forEach(qualification => {
          params.append('qualifications[]', qualification)
        })
      }

      if (preferences.length > 0) {
        preferences.forEach(preference => {
          params.append('preferences[]', preference)
        })
      }

      let url = window.location.pathname

      if (params.toString()) {
        url += `?${params.toString()}`
      }

      window.location.href = url
    }

    // Private methods

    _setBodyOverflow(value) {
      document.body.style.overflow = value
    }

    _toggleModalVisibility(isActive) {
      const action = isActive ? 'add' : 'remove'
      this.contentTarget.classList[action](this.constructor.CLASSES.ACTIVE_CONTENT)
      this.overlayTarget.classList[action](this.constructor.CLASSES.ACTIVE_OVERLAY)
    }

    _getCheckedValues(name) {
      const checkboxes = this.element.querySelectorAll(`input[name="${name}"]:checked`)
      return Array.from(checkboxes).map(cb => cb.value)
    }

    _getCheckedRadioValue(name) {
      const radio = this.element.querySelector(`input[name="${name}"]:checked`)
      if (!radio) return null
      if (!radio.hasAttribute('value')) return null
      return radio.value
    }

    // CloudFrontのキャッシュにより、サーバーサイドで絞り込み条件を反映したHTMLが返らないため、
    // クライアントサイドでURLパラメータを読み取り、チェックボックスとラジオボタンの状態を更新する
    _restoreFilterStateFromParams() {
      const params = new URLSearchParams(window.location.search)

      const multiValueKeys = ['building_types[]', 'wall_materials[]', 'themes[]', 'insurance_types[]', 'available_services[]', 'qualifications[]', 'preferences[]']
      multiValueKeys.forEach(key => {
        const values = params.getAll(key)
        values.forEach(value => {
          const checkbox = this.element.querySelector(`input[name="${key}"][value="${value}"]`)
          if (checkbox) {
            checkbox.checked = true
          }
        })
      })

      const singleValueKeys = ['review_rating', 'review_count', 'construction_count', 'established_years']
      singleValueKeys.forEach(key => {
        const value = params.get(key)
        if (value) {
          const radio = this.element.querySelector(`input[name="${key}"][value="${value}"]`)
          if (radio) {
            radio.checked = true
          }
        } else {
          const defaultRadio = this.element.querySelector(`input[name="${key}"]:not([value])`)
          if (defaultRadio) {
            defaultRadio.checked = true
          }
        }
      })
    }
  }
)
